import { render, staticRenderFns } from "./SubmitAddendum.vue?vue&type=template&id=85ff3f74&scoped=true&"
import script from "./SubmitAddendum.vue?vue&type=script&lang=js&"
export * from "./SubmitAddendum.vue?vue&type=script&lang=js&"
import style0 from "./SubmitAddendum.vue?vue&type=style&index=0&id=85ff3f74&lang=scss&scoped=true&"
import style1 from "./SubmitAddendum.vue?vue&type=style&index=1&id=85ff3f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ff3f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85ff3f74')) {
      api.createRecord('85ff3f74', component.options)
    } else {
      api.reload('85ff3f74', component.options)
    }
    module.hot.accept("./SubmitAddendum.vue?vue&type=template&id=85ff3f74&scoped=true&", function () {
      api.rerender('85ff3f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/addendum/SubmitAddendum.vue"
export default component.exports